export const SITE = {
  nombre: "Tulevik Legal",
  lema: "Contigo, propagando valores, defendiendo el futuro.",
  tagline: "Derecho para los momentos donde tu vida se decide.",
  ubicacion: "Texcoco, Estado de México",
  alcance: "Texcoco y Valle de México",
  // Llamada de disponibilidad (ex consulta gratuita): restricción definida por el despacho.
  disponibilidad: "Llamada de disponibilidad: 15 a 20 minutos máximo, sin costo.",
  // Número de WhatsApp del despacho en formato internacional (p. ej. "5215512345678").
  // Mientras esté vacío, los botones de WhatsApp llevan al formulario de contacto.
  WHATSAPP_NUMERO: "",
};

export function whatsappHref(mensaje = "Hola, quiero contar mi situación."): string {
  if (!SITE.WHATSAPP_NUMERO) return "/contacto";
  return `https://wa.me/${SITE.WHATSAPP_NUMERO}?text=${encodeURIComponent(mensaje)}`;
}

export const CTAS = {
  principal: { label: "Cuéntanos tu situación", href: "/contacto" },
  secundaria: { label: "Habla con nosotros", href: whatsappHref() },
  prioritaria: { label: "Atención prioritaria", href: "/atencion-prioritaria" },
};

export const NAV_LINKS = [
  { label: "Momentos", href: "/momentos" },
  { label: "Servicios", href: "/servicios" },
  { label: "Método", href: "/como-te-acompanamos" },
  { label: "Guías", href: "/guias" },
];

export const TRES_PUERTAS = [
  {
    n: "01",
    titulo: "Por momento de vida",
    desc: "Identifica tu situación por lo que está pasando en tu vida: tu casa, tu pareja, tu trabajo, tu familia.",
    href: "/momentos",
    cta: "Explorar momentos",
  },
  {
    n: "02",
    titulo: "Por servicio",
    desc: "Si ya sabes qué tipo de asunto tienes, entra directo al área que corresponde.",
    href: "/servicios",
    cta: "Ver servicios",
  },
  {
    n: "03",
    titulo: "Encuentra tu ruta",
    desc: "Responde tres preguntas y recibe orientación inicial: área sugerida, documentos y siguiente paso.",
    href: "/orientador",
    cta: "Usar el orientador",
  },
];

export const METODO = [
  {
    n: "01",
    titulo: "Cuéntanos tu situación",
    desc: "Escríbenos por el formulario o agenda una llamada de disponibilidad (15 a 20 minutos, sin costo). Nos cuentas qué pasa, sin tecnicismos.",
  },
  {
    n: "02",
    titulo: "Clasificamos tu asunto",
    desc: "Identificamos el área, los documentos que aplican y si tu asunto es algo en lo que podemos ayudarte. Si no es para nosotros, te lo decimos.",
  },
  {
    n: "03",
    titulo: "Plan claro por escrito",
    desc: "Antes de empezar: alcance, tiempos y costos. Nada comienza sin que sepas hasta dónde llega el trabajo y cuánto cuesta.",
  },
  {
    n: "04",
    titulo: "Acompañamiento",
    desc: "Ejecutamos el plan con seguimiento y un punto de contacto. Te mantenemos al tanto en cada cambio importante.",
  },
];

export const COMPROMISOS = [
  {
    titulo: "Claridad desde la primera conversación",
    detalle: "Te explicamos tu asunto en palabras sencillas, sin llenarnos de tecnicismos.",
  },
  {
    titulo: "Honestidad sobre el alcance",
    detalle: "Si tu asunto no es para nosotros, te lo decimos y te orientamos hacia dónde sí.",
  },
  {
    titulo: "Costos antes de empezar",
    detalle: "Ningún trabajo comienza sin que sepas cuánto cuesta y hasta dónde llega.",
  },
  {
    titulo: "Sin promesas de resultado",
    detalle: "Comprometemos esfuerzo, método y comunicación, nunca veredictos garantizados.",
  },
  {
    titulo: "Confidencialidad",
    detalle: "Lo que nos cuentas se queda con nosotros. Tratamos tu información con respeto.",
  },
  {
    titulo: "Respuesta en horario hábil",
    detalle: "No prometemos 24/7. Prometemos constancia: respondemos de lunes a viernes.",
  },
];

export const CONCIERGE_LEGAL = {
  eyebrow: "Concierge Legal",
  titulo: "El mismo estándar, un nivel aparte.",
  desc: "Para el ejecutivo que requiere presencia y enfoque —también en su casa—: tu actividad profesional no debería detener tu vida de familia, y los asuntos legales no son la excepción. Nosotros nos ajustamos: un punto de contacto directo, discreción y prioridad, todo coordinado con tu agenda y no al revés.",
  puntos: [
    "Un punto de contacto directo: hablas con quien decide, sin filas ni intermediarios.",
    "Discreción por diseño: tu asunto se trata en privado y se queda en privado.",
    "Donde tú estés: en tu oficina, a distancia o donde se tome la decisión.",
  ],
  nota: "Respuesta prioritaria en horario hábil. Alcance y costos, siempre por escrito.",
};

export const REDES_SOCIALES = [
  // Agrega la URL cuando la cuenta exista; mientras esté vacía, no se muestra el ícono.
  { id: "linkedin", label: "LinkedIn", url: "https://www.linkedin.com/company/tulevik-legal/" },
  { id: "facebook", label: "Facebook", url: "https://www.facebook.com/tulevik" },
  { id: "instagram", label: "Instagram", url: "" },
  { id: "tiktok", label: "TikTok", url: "" },
];

export const REDES_ACTIVAS = REDES_SOCIALES.filter((r) => r.url);

export const TEMAS_CONTACTO = [
  "Bienes y patrimonio",
  "Familia y acuerdos",
  "Defensa laboral",
  "Seguros y siniestros",
  "Protección del consumidor",
  "Protección digital",
  "Asesoría de negocios",
  "Concierge Legal",
  "Otro asunto",
];

export const QUE_HACEMOS = {
  hacemos: [
    "Orientación inicial clara sobre tu situación",
    "Estrategia jurídica con alcance, tiempos y costos por escrito",
    "Trámites, contratos, negociación y representación cuando procede",
    "Seguimiento constante y un punto de contacto real",
  ],
  noHacemos: [
    "No prometemos resultados ni 'ganamos siempre'",
    "No aceptamos asuntos que requieren especialidad que no tenemos",
    "No damos asesoría definitiva por chat o redes sociales",
    "No usamos tu información para nada fuera de tu asunto",
  ],
};

export const DISCLAIMER_GUIAS =
  "Esta guía es informativa y general. No constituye asesoría jurídica ni sustituye la revisión de tu caso concreto por una profesional del derecho.";

export const DISCLAIMER_ORIENTADOR =
  "El orientador es una herramienta de clasificación informativa. No constituye diagnóstico legal, opinión jurídica ni scoring de riesgo. No guarda tus respuestas.";

export const FOOTER_DISCLAIMER =
  "La información de este sitio tiene fines informativos y no constituye asesoría jurídica.";
